import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";
import techDevImage from "../tecdev.png";

const LandingPage = ({
	isAdmin,
	isManager,
	isTrainer,
	isSpear,
	trainerID,
	selfAlias,
	permissionsFetched,
}) => {
	const navigate = useNavigate();

	useEffect(() => {
		if (!permissionsFetched) return;

		if (isAdmin || isManager) {
			navigate("/mhe-home");
			return;
		}

		if (selfAlias) {
			navigate(`/details/${selfAlias}`);
		}
	}, [isAdmin, isManager, selfAlias, permissionsFetched, navigate]);

	const handleCardClick = (route, isAllowed) => {
		if (isAllowed) {
			console.log(`Navigating to ${route}`);
			navigate(route);
		} else {
			console.log("Access Denied");
		}
	};

	const handleMheClick = () => {
		if (isAdmin || isManager) {
			navigate("/mhe-home");
			return;
		}

		if (selfAlias) {
			navigate(`/details/${selfAlias}`);
			return;
		}

		if (!permissionsFetched) {
			console.log("Permissions not loaded yet");
			return;
		}

		console.log("No self alias found");
	};

	return (
		<div className="landing-page">
			<img src={techDevImage} alt="Tech Dev Logo" className="landing-image" />
			<h1>Welcome to Tech Dev</h1>

			<div className="cards-container">
				<div
					className="landing-card mhe-card"
					onClick={handleMheClick}
					style={{
						cursor:
							isAdmin || isManager || isTrainer || isSpear || !!selfAlias
								? "pointer"
								: "not-allowed",
					}}
				>
					<h2>Tech Dev - MHE</h2>
				</div>

				<div
					className="landing-card csx-card disabled"
					onClick={() => handleCardClick("/csx-home", isAdmin)}
					style={{ cursor: isAdmin ? "pointer" : "not-allowed" }}
				>
					<h2>Tech Dev - CSX</h2>
					<p className="under-development">Under Development</p>
				</div>

				<div
					className="landing-card rmep-card disabled"
					onClick={() => handleCardClick("/rmep-home", isAdmin)}
					style={{ cursor: isAdmin ? "pointer" : "not-allowed" }}
				>
					<h2>Tech Dev - RMEP</h2>
					<p className="under-development">Under Development</p>
				</div>
			</div>
		</div>
	);
};

export default LandingPage;
